// src/TypingIndicator.tsx
import React from "react";

interface Props {
  typingUsers: string[];
}

const TypingIndicator: React.FC<Props> = ({ typingUsers }) => {
  if (typingUsers.length === 0) return null;

  return (
    <div style={{ fontSize: 13, opacity: 0.7, padding: "0 20px 8px" }}>
      {typingUsers.join(", ")} {typingUsers.length > 1 ? "are" : "is"} typing...
    </div>
  );
};

export default TypingIndicator;
